import { THEME_STORAGE_KEY } from "../theme";
import { TOUR_KEYS } from "./tours";

/**
 * Signing in or out wipes the browser's saved state, but the theme and the "tour seen" flags
 * are device preferences, not account data, so they are kept.
 */
export function clearAppStorage() {
    const kept = {};
    try {
        [THEME_STORAGE_KEY, ...TOUR_KEYS].forEach((key) => {
            const value = localStorage.getItem(key);
            if (value !== null) kept[key] = value;
        });
    } catch {
        // Storage may be unavailable; nothing to keep.
    }
    localStorage.clear();
    sessionStorage.clear();
    Object.entries(kept).forEach(([key, value]) => localStorage.setItem(key, value));
}
